import { Component, Input } from '@angular/core';
import { SvcBtnBaseComponent } from '../svc-btn-base.component';
import { MatRipple } from '@angular/material/core';

@Component({
  selector: '[svc-btn]',
  templateUrl: './svc-btn.component.html',
  styleUrls: ['./svc-btn.component.scss'],
  hostDirectives: [{ directive: MatRipple, inputs: ['matRippleDisabled:disabled'] }],
  host: {
    '[class.svc-btn]': `true`,
    '[class.svc-btn-danger]': `color === 'danger'`,
    '[class.svc-btn-text]': `color === 'text'`,
    '[class.svc-btn-primary]': `color === 'primary'`,
    '[class.svc-btn-on-primary]': `color === 'on-primary'`,
    '[class.svc-btn-link-type]': `type === 'link'`,
    '[class.svc-btn-disabled]': `processing || disabled`,
  },
})
export class SvcBtnComponent extends SvcBtnBaseComponent {
  @Input() public type: 'default' | 'link' = 'default';
}
